import {AgentPreferences, defaultPrefs} from "../util/defaultPrefs.tsx";

export const defaultSupervisorPrefs: AgentPreferences = {
    ...defaultPrefs,
    inspectionTierColors: [
        {tier: "PRELIM", color: "danger", watched: true},
        {tier: "NOTHING", color: "primary", watched: false},
        {tier: "FINAL", color: "success", watched: false},
        {tier: "SURCHARGE", color: "neutral", watched: false},
    ],
};






